import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import * as userService from '../services/userService'
import { toast } from "react-toastify";

class ResetPasswordForm extends Form {
  state = {
    data: { password: "" },
    errors: {}
  };

  schema = {
    password: Joi.string()
      .required()
      .min(5)
      .label("Password")
  };

  doSubmit = async () => {
    // Call the server
    try {
      const sp = new URLSearchParams(this.props.location.search),
        reset_token = sp.get('reset_token');
      await userService.resetPassword(reset_token, this.state.data.password);
      toast.info(
        "Password successfully reset. Redirecting to login page..",
        { onClose: () => { window.location = "/login"; }}
      );
      
    }
    catch(ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        
      }
    }
  };

  render() {
    console.log(this.props.location);
    return (
      <div>
        <h1>Reset password</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("password", "Password", "password")}
          {this.renderButton("Reset Password")}
        </form>
      </div>
    );
  }
}

export default ResetPasswordForm;